import React from 'react';
import StaffPerformance from '.';

export default function MyPerformance(props){
    return <StaffPerformance {...props} isMyPerformance />
}